module.exports = __webpack_public_path__ + "assets/images/green-xmas-2.jpg?v=97dd3519";